import {fetchWithJsonData} from "../lib/fetch.js";
import {PopupNotification} from "../lib/PopupNotification.js";
import {EMAIL_VALIDATION_REGEX} from "../../utility/validation.js";
import {decodeRedirectUri} from "../../data/utility/encoder.js";

const inputEmail = <HTMLInputElement>document.getElementById("input-email");
const inputPassword = <HTMLInputElement>document.getElementById("input-password");
const buttonLogin = <HTMLButtonElement>document.getElementById("button-login");
const notificationElementWrongCredentials = <HTMLDivElement>document.getElementById("notification-wrong-credentials");

const notificationWrongCredentials = new PopupNotification(notificationElementWrongCredentials);

buttonLogin.addEventListener("click", async () => {
    const email = inputEmail.value;
    const password = inputPassword.value;
    let validationError = false;

    if(!EMAIL_VALIDATION_REGEX.test(email)){
        validationError = true;
    }
    if(password.length < 4){
        validationError = true;
    }

    if(validationError){
        notificationWrongCredentials.show();
        return;
    }

    const response = await fetchWithJsonData("/auth/login", {
        method: "POST",
        body: JSON.stringify({
            email,
            password
        })
    });

    if(response.ok){
        const redirectPath: string | null = new URL(globalThis.location.href).searchParams.get("r");

        if(redirectPath !== null && redirectPath.length > 0){
            globalThis.location.href = decodeRedirectUri(redirectPath);
        }else{
            globalThis.location.href = "/";
        }
    }else{
        inputPassword.value = "";
        notificationWrongCredentials.show();
    }
});

inputPassword.addEventListener("keyup", (event: Event) => {
    // Login using the enter-key when writing password
    if((<KeyboardEvent>event).key === "Enter"){
        buttonLogin.click();
    }
});